<template lang="pug">
	#main-wrapper(:class="{ 'login-background': isLoginRoute }")
		el-container
			el-header(height="98px")
				menu-header
			.content
				el-main#container
					back-bar.backLogin(v-if="isLoginRoute", color="#FFFFFF")
					view-layout
						router-view
				footer-bar
</template>

<script>
import MenuHeader from "./MenuHeader";
import ViewLayout from "./ViewLayout";
import FooterBar from "./FooterBar";
import BackBar from "./BackBar.vue";

export default {
  name: "MainPage",
  components: { ViewLayout, MenuHeader, FooterBar, BackBar },
  data() {
    return {
      isLoginRoute: false
    };
  },
  watch: {
    $route(to) {
      this.isLoginRoute = to.path.includes("/login");
    }
  },
  created() {
    this.isLoginRoute = this.$route.path.includes("/login");
  }
};
</script>

<style lang="sass">
@import '../../theme/tools/variables'

#main-wrapper, .el-container
	height: 100vh
	width: 100vw

#main-wrapper.login-background
	background-image: url('../../assets/fundo-rio-amazonas.png')
	background-size: cover;
	background-position: center;

.el-header
	background-color: white
	padding: 0 !important
	z-index: 1000

.content
	display: block
	overflow: auto

.backLogin
	margin-left: 20px
</style>
